// extracted by mini-css-extract-plugin
export default {"buttons":"Login_buttons__EgS7g","paper":"Login_paper__qIpVf","lock":"Login_lock__J9iKk"};